<template>
  <div
    class="container v-content-container tooltip-wrapper popup-wrapper"
    :key="componentKey"
  >
    <div class="row">
      <div class="col-xs-12">
        <h1>
          <i class="fa fa-user fa-fw fa-list-alt"></i>
          {{ $label("event.event_categories", "Event categories") }}
          <router-link
            :to="{ name: 'NewEventCategory' }"
            class="btn btn-v-lightgreen-white pull-right"
            v-tooltip="{
              content: $label('category.new_category', 'New category'),
              classes: 'custom-tooltip'
            }"
          >
            <i class="fa fa-fw fa-lg fa-plus"></i>
          </router-link>
        </h1>
      </div>
    </div>

    <navigation-tabs></navigation-tabs>

    <div class="row mt-8">
      <div class="col-xs-12">&nbsp;</div>
    </div>

    <alert-box
      v-show="failedRequest"
      type="warning"
      :closeable="false"
      :show-icon="false"
    >
      {{
        $label(
          "event.categories_failed_request",
          "Request failed while loading categories."
        )
      }}
    </alert-box>

    <Table
      v-show="!failedRequest"
      id="categories-table"
      :loading="loading"
      :columns="[
        {
          title: 'Category',
          field: 'name',
          id: row => `category-name-${row.id}`
        },
        {
          title: 'Number of courses',
          field: 'courses_count',
          id: row => `category-courses-count-${row.id}`
        },
        {
          title: 'Booking restrictions',
          field: 'Unlimitiert',
          id: row => `category-booking-restriction-${row.id}`
        }
      ]"
      :actions="[
        {
          type: 'detail',
          onClick: row => {
            $router.push({
              name: 'EventCategoryDetails',
              params: { category_id: row.id }
            });
          }
        },
        {
          type: 'delete',
          id: row => `delete-category-button-${row.id}`,
          onClick: row => deleteCategory(row.id)
        }
      ]"
      :data="categories"
      :meta="metaData"
      @fetchQuery="
        params => {
          fetchParams = params;
          getCategories({
            //
          });
        }
      "
    >
      <div
        id="action-dropdown"
        slot="toolbar"
        class="btn-group"
        style="margin-left: 5px;"
      >
        <button
          type="button"
          class="btn btn-primary dropdown-toggle"
          data-toggle="dropdown"
        >
          <i class="fa fa-refresh"></i> &nbsp;
          {{ $label("common.actions", "Actions") }} &nbsp;<span
            class="caret"
          ></span>
        </button>
        <ul class="dropdown-menu" role="menu">
          <li>
            <router-link :to="{ name: 'NewEventCategory' }"
              ><i class="text-primary fa fa-fw fa-lg fa-plus"></i>
              {{ $label("category.new_category", "New category") }}</router-link
            >
          </li>
        </ul>
      </div>
    </Table>

    <div class="row mb-8">
      <div class="col-xs-12">&nbsp;</div>
    </div>
  </div>
</template>

<script>
import Api from "@/api.js";
import swal from "sweetalert";

import Table from "@/components/Common/Table";
import AlertBox from "@/components/Common/Alerts/AlertBox";
import NavigationTabs from "@/components/Settings/Events/NavigationTabs.vue";

export default {
  name: "EventCategories.vue",

  components: {
    Table,
    AlertBox,
    NavigationTabs
  },

  data() {
    return {
      categories: [],
      loading: false,
      updating: false,
      failedRequest: false,
      metaData: null,
      fetchParams: {
        page: 1,
        per_page: null,
        to: 1,
        search: ""
      },
      selectedCategoryId: null,
      componentKey: 0
    };
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (
        vm.$route.query.category_deleted === true ||
        vm.$route.query.category_deleted === "true"
      ) {
        swal("Success!", "The category was deleted.", "success").then(() => {
          window.history.pushState(
            {},
            document.title,
            window.location.pathname
          );
        });
      }
      vm.getCategories(() => {
        //
      });
    });
  },

  beforeRouteUpdate(to, from, next) {
    if (to.query.category_deleted === true) {
      swal("Success!", "The category was deleted.", "success").then(() => {
        window.history.pushState({}, document.title, window.location.pathname);
      });
    }
    this.forceRerender();
    if (
      this.fetchParams.to % this.fetchParams.per_page === 0 &&
      this.fetchParams.page !== 1
    ) {
      this.fetchParams.page -= 1;
    }
    this.getCategories(() => {
      //
    });
    next();
  },

  mounted() {
    //
  },

  methods: {
    getCategories(successCallback) {
      if (this.loading) {
        return;
      }

      this.loading = true;
      this.categories = [];
      const endpoint = this.$partnerEndpoint("categories");

      Api()
        .get(endpoint, {
          params: {
            page: this.fetchParams.page,
            search: this.fetchParams.search
          }
        })
        .then(response => {
          this.categories = response.data.data;
          this.metaData = response.data.meta;
          this.failedRequest = false;
          if (typeof successCallback == "function") {
            successCallback();
          }
        })
        .catch(() => {
          this.failedRequest = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    deleteCategory(categoryId) {
      this.selectedCategoryId = categoryId;
      if (this.loading || this.updating || this.selectedCategoryId == null) {
        return;
      }

      swal({
        title: "Are you sure?",
        text: "The category will be deleted",
        icon: "warning",
        dangerMode: true,
        buttons: {
          cancel: {
            visible: true,
            text: "Cancel",
            closeModal: true
          },
          confirm: {
            visible: true,
            text: "Yes, delete it!",
            closeModal: true
          }
        }
      }).then(isConfirm => {
        if (isConfirm) {
          const endpoint = this.$partnerEndpoint(
            "categories/" + this.selectedCategoryId
          );

          Api()
            .delete(endpoint)
            .then(() => {
              this.$router
                .push({
                  name: "EventCategories",
                  query: { category_deleted: true }
                })
                .catch(error => {
                  console.log(error);
                  if (
                    error.name === "NavigationDuplicated" ||
                    error.message.includes(
                      "Avoided redundant navigation to current location"
                    )
                  ) {
                    swal("Success!", "The category was deleted.", "success");
                    this.getCategories(() => {
                      //
                    });
                  }
                });
            })
            .catch(error => {
              if (error.response.status === 403) {
                swal({
                  title: "Missing permission",
                  text: "You are not allowed to delete categories.",
                  icon: "error"
                  //dangerMode: true,
                });
              }
            });
        } else {
          //
        }
      });
    },

    forceRerender() {
      this.componentKey += 1;
    },

    isActiveTab(tab) {
      return this.$route.name == tab;
    }
  }
};
</script>

<style scoped>
.mt-0 {
  margin-top: 0rem;
}

.mt-8 {
  margin-top: 1.3rem;
}

.mb-0 {
  margin-bottom: 0rem;
}

.mb-1 {
  margin-bottom: 0.3rem;
}

.mb-2 {
  margin-bottom: 0.6rem;
}

.mb-8 {
  margin-bottom: 1.3rem;
}
</style>
